import CartRow from "./CartRow.jsx";

export default function CartItems({
	items,
	itemCount,
	busyKeys,
	loading,
	onUpdateQty,
	onRemove,
	onClearCart,
	presentation = {},
	notices = null,
	empty = null,
}) {
	const Heading = presentation.title ? 'h1' : 'h2';
	return (
		<div className={`zc-items${loading ? " is-loading" : ""}`}>
			{/* Header: title + clear */}
			<div className="zc-items__header">
				<Heading className="zc-items__title">
					{presentation.title || 'Cart'}{" "}
					{presentation.showCount !== false && <span className="zc-items__count">
						({itemCount} {itemCount === 1 ? "product" : "products"})
					</span>}
				</Heading>
				{presentation.showClear !== false && <button
					className="zc-items__clear"
					disabled={loading}
					onClick={onClearCart}
					type="button"
				>
					<span aria-hidden="true">&times;</span> Clear cart
				</button>}
			</div>
			{notices}
			{empty}

			{/* Column labels */}
			{!empty && presentation.showColumns !== false && <div className="zc-items__cols">
				<span className="zc-items__col-product">Product</span>
				<span className="zc-items__col-count">Count</span>
				<span className="zc-items__col-price">Price</span>
				<span className="zc-items__col-remove" />
			</div>}

			{/* Item rows */}
			<div className="zc-items__list">
				{items.map((item) => (
					<CartRow
						key={item.key}
						item={item}
						presentation={presentation}
						busy={loading || busyKeys.has(item.key)}
						onUpdateQty={onUpdateQty}
						onRemove={onRemove}
					/>
				))}
			</div>
		</div>
	);
}
